import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import { blue } from "@mui/material/colors";

const drawerWidth = 270;
const drawerWidthMobile = "auto";
export const openedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  width: drawerWidthMobile,
  zIndex: 2000,
  paddingRight: 15,
  backgroundColor: "#fcfcfc",
  paddingBottom: "20%",
  height: "100vh", // Garante que ocupe toda a altura
  overflowY: "auto", // Permite scroll se necessário
  [theme.breakpoints.up("sm")]: {
    width: drawerWidth,
    zIndex: 2,
    paddingRight: 0,
    paddingBottom: "5%",
    backgroundColor: "#fcfcfc",

    height: "100vh",
  },
});

export const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(0)} + 1px)`,
  backgroundColor: "#fcfcfc",
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
    backgroundColor: "#fcfcfc",
  },
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: 10,
  backgroundColor: "#fcfcfc !important",

  ...theme.mixins.toolbar,
}));

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "#fcfcfc",
  color: "#000",
  // boxShadow: "1px 3px 1px #eee",
  boxShadow: "none",

  borderBottom: "",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const useStyle = makeStyles((theme) => ({
  drawerContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },

  menuListContainer: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
  },

  copyrightFooter: {
    marginTop: "auto",
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: "#fcfcfc",
    display: "flex",
    justifyContent: "center",
  },
  textItemList: {
    "& .MuiListItemText-root span": {
      fontSize: "0.75rem !important",
    },
    "& .MuiListItemIcon-root ": {
      "& svg": {
        fontSize: "1.3rem !important",
      },
    },
  },

  check: {
    position: "relative",
    "& .MuiListItemText-root span": {
      fontWeight: "bold !important",
    },
    "& .MuiListItemIcon-root ": {
      "& svg": {
        fontWeight: "bold !important",
      },
    },
    "&:before": {
      position: "absolute",
      content: '""',
      left: "0.03rem",
      background: theme.palette.primary.main,
      width: ".3rem",
      height: "2rem",
      top: ".5rem",
    },
  },
  DrawerHeader: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      alignItems: "center",
    },
  },
  Logo: {
    width: "7em",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      my: 0,
      alignItems: "left",
    },
  },
  ListItem: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#fcfcfc !important",
    padding: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up("sm")]: {
      position: "static",
      borderTop: "none",
      padding: theme.spacing(2),
      maxWidth: "100%",
    },
  },

  subMenuDisabled: {
    opacity: 0.4,
    color: theme.palette.text.disabled,
  },

  subMenu: {
    opacity: 0.8,
  },
  subMenuCheck: {
    opacity: 1,
    "& .MuiSvgIcon-root ": {
      color: theme.palette.primary.main + "!important",
      strokeWidth: "1",
    },
    "& span": {
      color: theme.palette.primary.main + "!important",
    },
  },
  ListItemText: {
    "&:hover": {
      textDecoration: "none",
    },
  },
}));
